import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/** The way out of a finished Action wizard. */
const ReturnToActions: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Link to="/zenith/workflows" className="btn-primary text-sm font-semibold">
      {t("zenith.workflows.return_to_actions")}
    </Link>
  );
};

export default ReturnToActions;
